(function($) {

    var avisCustomCode = function() {

      var avpContainer = null;
  
      // Don't allow negative numbers, by setting the 'min' attribute to the current value
      function fix_number_input_min_value() {
        avpContainer.querySelectorAll('input[type="number"]').forEach(function(el) {
          if (el.hasAttribute('min') && el.getAttribute('min') === '' && el.value) {
            //console.log(el);
            el.setAttribute('min', el.value);
          }
        });
      }
  
      // Junior Golf Camps
      // Keep track of when a Tiny Tee or Birdie is checked so that the 2nd Tiny Tee or Birdie is with Discount
      function junior_golf_camps_track_choice() {
          var selected = {};

          var countSelected = function(el) {
            var tinyCount = Object.keys(selected).filter(id => selected[id].includes('Tiny')).length;
            var $hiddenTiny = $(avpContainer).find('.count-tiny-tees input');
            $hiddenTiny.val(tinyCount).change();
  
            var birdieCount = Object.keys(selected).filter(id => selected[id].includes('Birdie')).length;
            var $hiddenBirdie = $(avpContainer).find('.count-birdies input');
            $hiddenBirdie.val(birdieCount).change();
            
            //console.log('$hiddenTiny: ', $hiddenTiny.val());
            //console.log('$hiddenBirdie: ', $hiddenBirdie.val());
            //console.log('-----------');
          }

          // For cart page edit options, on load count qty of ticket type selections by value
          $('input[name*="Ticket Type"]:checked, input[name*="Tipo de Bilhete"]:checked').each(function() {
            var $el = $(this);
            var id = $el.closest('.avp-option').attr('aria-labelledby');
            selected[id] = $el.val();
            //console.log($el, $el.val());
          });
          countSelected();
        
          $(document).on('click', 'input[name*="Ticket Type"], input[name*="Tipo de Bilhete"]', function(event) {
              //console.log('click');
              let $el = $(this);
              var id = $el.closest('.avp-option').attr('aria-labelledby');
              setTimeout(function() {
                var checked = $el.is(':checked');
                var val = $el.val();
                selected[id] = checked ? val : '';
                countSelected();
              }, 100);
          });
      }

      function run() {
        avpContainer = document.querySelector('[class*="avpoptions-container"]');
        if (avpContainer) {
          //console.log("QDL - Avis Run custom code");
          fix_number_input_min_value();
          junior_golf_camps_track_choice();
        }
      }
      
      document.addEventListener("avisOptionsLoaded", function() {
        //console.log('QDL - avisOptionsLoaded');
        run();
      });
      
    };
  
  	var customizeLangFilter = function() {
      
      $(function() {

        var counter = setInterval(function() {
          var $lang = $('.ht-tms-dropdown');
          if ($lang.length) {
            $lang.find('#pt-PT .ht-tms-dropdown__list-item__label').text('PT');
            clearInterval(counter);
          }
        }, 500);

      });
	}
    
    var adjustMobilePadding = function() {
      
      var adjust = function() {
        var winWidth = $(window).width();
        
        if (winWidth <= 768) {
          if (!$('.header-bar').attr('tabindex')) {
            var headerBarHeight = $('.header-bar').outerHeight(true);
            $('body').css({'padding-top': headerBarHeight}); 
          }
        } else {
          $('body').css({'padding-top': ''}); 
        }
      }
      
      $(function() {
      	adjust();
      });
      
      $(window).on('load', function() {
		adjust();
	  });
     
      $(window).on('resize', function() {
       	adjust(); 
      });
    }
  
	var pdfPopup = function() {
      
      	// OPEN
		//$('.product-single a[href*=".pdf"]').on('click', function(event) {
      	$('.file-open-popup').on('click', function(event) {
          	console.log('clicked');
			event.preventDefault();
//           	var pdfUrl = $(this).attr('href') + '#toolbar=0&navpanes=0&scrollbar=0';
          var pdfUrl = $(this).attr('href') + '';
          	
          	$('.popup-container.popup-pdf .popup__content--text')
            .html('<object data="'+ pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0" type="application/pdf"><iframe src="https://docs.google.com/viewer?url=' + pdfUrl + '&embedded=true"></iframe></object>');
          
          	$('.popup-container.popup-pdf').addClass('popup__open');
		});
      
      	
      	// CLOSE
		$(document).on('click', '.popup__close', function() {
			$(this).closest('.popup-container').removeClass('popup__open');
		});
      
		$(document).on('click', '.popup-container', function(event) {
			var $contentSection = $(this).find('.popup');
			if (!$contentSection.is(event.target) && $contentSection.has(event.target).length === 0) {
				$(this).closest('.popup-container').removeClass('popup__open');
			}
		});
    }
    
    var changeVariantDescp = function() {
      $(document).on('change', '.single-option-selector', function(e) {
         //console.log('changed variant');
        var $selected = $(this).find('option:selected');
        var selectedIndex = $selected.index();
        //console.log(selectedIndex);
        
        if (typeof variantDescps[selectedIndex] != 'undefined') {
          var vDescp =  variantDescps[selectedIndex];
          $('.product-description').html(vDescp);
        }
      });
    }

    // Unhide .debug sections passing ?debug=true in the url
    var debugMode = function() {
      // Check if URL has debug=true parameter
      document.addEventListener('DOMContentLoaded', function() {
        const urlParams = new URLSearchParams(window.location.search);
        const debugMode = urlParams.get('debug');
        
        if (debugMode === 'true') {
          // Find all elements with class 'debug'
          const debugElements = document.querySelectorAll('.debug');
          
          // Set each element's display to 'block'
          debugElements.forEach(function(element) {
            element.style.display = 'block';
          });
          
          // Optional: Log to console for verification
          console.log('Debug mode activated. ' + debugElements.length + ' debug elements displayed.');
        }
      });
    }

 
    debugMode();
    avisCustomCode();
	customizeLangFilter();
	adjustMobilePadding();
  	pdfPopup();
  	//changeVariantDescp();

})(jQuery);